export const TEST_ID = 'callToActionNavigationLink';
